var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.listWithLastEmptyItem),function(item,index){return _c('div',{key:index},[_c('app-input',{attrs:{"type":"text","value":item,"placeholder":_vm.placeholder},on:{"input":value => {
                    _vm.handleInput(index, value)
                }}})],1)}),(!!_vm.errorMessage)?_c('span',{staticClass:"cf-c-input__error"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }